import React, { useEffect, useState } from 'react';
import { Button } from "@components/ui/button";
import { CookieManager } from '@utils/cookieManager';

const COOKIE_CONSENT_KEY = 'cookie-consent';

const CookieConsent: React.FC = () => {
  const [isVisible, setIsVisible] = useState<boolean>(true);

  useEffect(() => {
    // Check for existing consent cookie
    const existingConsent = CookieManager.get(COOKIE_CONSENT_KEY);
    if (existingConsent) {
      setIsVisible(false);
    }
  }, []);

  const handleAcceptAll = () => {
    CookieManager.set(COOKIE_CONSENT_KEY, 'accepted', {
      expires: 365, // Cookie expires in 1 year
      path: '/',
      sameSite: 'Lax'
    });
    // Here you would initialize analytics/tracking
    setIsVisible(false);
  };

  const handleAcceptNecessary = () => {
    CookieManager.set(COOKIE_CONSENT_KEY, 'necessary', {
      expires: 365,
      path: '/',
      sameSite: 'Lax'
    });
    // Here you would disable optional cookies/tracking
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[100] border-t shadow-lg" style={{ backgroundColor: 'var(--primary-900)' }}>
      <div className="max-w-7xl mx-auto p-4">
        <div className="flex items-center justify-between gap-8">
          <div className="space-y-1 flex-1">
            <h3 className="font-semibold text-lg text-white">Cookie Settings</h3>
            <p className="text-sm text-slate-200">
              We use cookies to enhance your browsing experience and analyze our traffic. 
              These include necessary cookies for site functionality and optional analytics cookies.
            </p>
          </div>
          
          <div className="flex items-center gap-4 shrink-0">
            <Button
              variant="outline"
              onClick={handleAcceptNecessary}
              className="whitespace-nowrap bg-white text-primary-900 hover:bg-slate-200"
            >
              Necessary Only
            </Button>
            <Button
              onClick={handleAcceptAll}
              className="whitespace-nowrap bg-white text-primary-900 hover:bg-slate-200"
            >
              Accept All
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent; 